// extracted by mini-css-extract-plugin
export default {"shimmer":"styles_shimmer__Oa1KV","shimmerMove":"styles_shimmerMove__T82eQ"};